"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsRequestSerialiser = exports.MetricsRequestSerialiserClass = void 0;
var metrics_request_1 = require("./../../features/metrics/metrics-request");
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for metrics requests.
 */
var MetricsRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MetricsRequestSerialiserClass, _super);
    function MetricsRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a metrics request to the stream
     *
     * @param bos    the output stream
     * @param value  the metrics request
     */
    MetricsRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeCollection(bos, __spreadArray([], __read(value.filters.values())), Codec.writeString);
        Codec.writeString(bos, value.pattern);
        BEES.write(bos, value.requestType);
        if (value.requestType === metrics_request_1.RequestType.NAMED_SERVER) {
            Codec.writeString(bos, value.server);
        }
    };
    return MetricsRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MetricsRequestSerialiserClass = MetricsRequestSerialiserClass;
/**
 * The singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.MetricsRequestSerialiser = new MetricsRequestSerialiserClass();
